export const landingDescription = "Full-stack Software Engineer based in the Bay Area.";

export const aboutDescription = [
    "First off, thanks for visiting my website! My name is Ben and I’m a software engineer specializing in Full-stack development.\n",
    "I enjoy working on projects and solving problems, whether if it’s fixing up my car or picking up a new coding language. Getting under the hood and figuring out how things work led me to pursue software development.\n",
    "I have over 6 years of coding experience, using industry standards such as React, Express and other popular frameworks. I am constantly finding new projects to enrich my knowledge and experience.\n",
    "Here are some of the technologies I’ve been working with recently:"
];

export const skills = [
    "Typescript",
    "Node",
    "React",
    "Flutter",
    "Express",
    "MongoDB",
    "Javascript", 
    "PHP", 
];